<template>
  <div id="app">
    <!--Header Starts Here-->
    <header class="header">
        <div class="container clearfix">
            <nav class="navbar navbar-default">
                <div class="navbar-header">
                    <router-link to="/#top" class="navbar-brand"> <img src="static/img/logo.png" alt="brand" /> </router-link>
                    <button type="button" class="navbar-toggle collapsed" data-toggle="collapse" data-target="#navbar" aria-expanded="false" aria-controls="navbar">
                        <span class="sr-only">Toggle navigation</span>
                        <span class="icon-bar">&nbsp;</span>
                        <span class="icon-bar">&nbsp;</span>
                        <span class="icon-bar">&nbsp;</span>
                    </button>
                </div>
                <div id="navbar" class="navbar-collapse collapse">
                    <ul class="nav navbar-nav">
                        <li>
                            <a href="#" v-if="this.$locale.current() === 'fr' || this.$locale.current() === null" @click="changeLang('en')"><b>EN</b></a><a href="#" v-else-if="this.$locale.current() === 'en'" @click="changeLang('fr')"><b>FR</b></a>
                        </li>
                        <li>
                            <router-link to="/#top">{{$t('Header.home')}}</router-link>
                        </li>
                        <li>
                            <router-link to="/#intro">{{$t('Header.about')}}</router-link>
                        </li>
                          <li>
                            <router-link to="/#influenceur">{{$t('Header.influenceur')}}</router-link>
                        </li>
                        <li>
                            <router-link to="/#quizz">{{$t('Header.quizz')}}</router-link>
                        </li>

                          <li>
                            <router-link to="faq">{{$t('Header.faq')}}</router-link>
                        </li>
                        <li>
                            <a href="https://chaperon.tunetoo.com" alt="chaperon boutique" v-bind:title="$t('Header.shop-title')" target="_blank" class>{{$t('Header.shop')}}</a>
                        </li>
                        <li>
                            <a href="https://blog.chaperon.me" alt="chaperon boutiquele blog" v-bind:title="Blog" target="_blank" class>Blog</a>
                        </li>
                        <!--
                        <li>
                            <router-link to="terms">Support</router-link>
                        </li>-->
                    </ul>
                </div>
            </nav>
        </div>
    </header>
    <!--Header End Here-->
    <router-view></router-view>
    <!--Footer Start -->
    <footer class="footer">
            <div class="container">
                <div class="footer__primary"><!--
                    <div class="footer__blocks">
                        <h5>Chaperon</h5>
                        <ul>
                            <li>
                                <a href="#">Qu'est ce que Chaperon?</a>
                            </li>
                            <li>
                                <a href="#">The Chaperon side </a>
                            </li>
                            <li>
                                <a href="#">The Bachelor side</a>
                            </li>
                            <li>
                                <a href="#">Press kit</a>
                            </li>
                            <li>
                                <a href="#">Testimonials</a>
                            </li>
                        </ul>
                    </div>-->

                    <div class="footer__blocks">
                        <h5>Pandaaz</h5>
                        <ul>
                            <li>
                                <a href="http://www.pandaaz.com" target="_blank" alt="Pandaaz" title="Pandaaz createur de l'app Chaperon">{{$t('Footer.about')}}</a>
                            </li><!--
                            <li>
                                <a href="#">The team </a>
                            </li>
                            <li>
                                <a href="#">Jobs</a>
                            </li>
                            <li>
                                <a href="#">Partnership</a>
                            </li>
                            <li>
                                <a href="#">Investors</a>
                            </li>-->
                        </ul>
                    </div>
                    <div class="footer__blocks">
                        <h5>Support </h5>
                        <ul><!--
                            <li>
                                <a href="#">FAQ</a>
                            </li>-->
                            <li>
                                <a href="/terms" alt="terms" title="conditions générales">{{$t('Footer.terms')}}</a>
                            </li>
                            <li>
                                <a href="/privacy" alt="privacy" title="confidentialité">{{$t('Footer.privacy')}}</a>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="footer__secondary text-center">
                    <ul>
                        <li>
                            <!--<a class="sprite-chat" href="#">&nbsp;</a>-->&nbsp;
                        </li>
                        <li>
                            <!--<a class="sprite-ytube" href="#">&nbsp;</a>-->&nbsp;
                        </li>
                        <li>
                            <a class="sprite-insta" href="https://www.instagram.com/chaperon_me" alt="chaperon instragram" v-bind:title="$t('Footer.chaperon-insta')" target="_blank">&nbsp;</a>
                        </li>
                        <li>
                            <a class="sprite-fb" href="https://www.facebook.com/chaperon.me" alt="chaperon facebook" v-bind:title="$t('Footer.chaperon-fb')" target="_blank">&nbsp;</a>
                        </li>
                        <li>
                            <!--<a class="sprite-twit" href="#">&nbsp;</a>-->&nbsp;
                        </li>
                    </ul>
                    <span>&copy;Copyright 2015 Chaperon.</span>
                </div>
            </div>
        </footer>
  </div>
</template>

<script>
export default {
  name: 'App',
  methods: {
    changeLang: function (newLang) {
      if (this.$cookies.get('lang_chap') !== newLang) {
        this.$cookies.set('lang_chap', newLang, 'Infinity')
        this.$locale.change(newLang)
        location.reload()
      }
    }
  },
  mounted: function () {
    if (this.$cookies.get('lang_chap') === '' || this.$cookies.get('lang_chap') === null) {
      this.$cookies.set('lang_chap', 'fr', 'Infinity')
    }
    this.$locale.change(this.$cookies.get('lang_chap'))
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// App.vue?0159ac9c